import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  user: {},
  friendList: [],
};

const userSlice = createSlice({
  name: "user",
  initialState: INITIAL_STATE,
  reducers: {
    addUser: (state, action = {}) => {
      const { payload: user } = action;
      state.user = user;
    },
    addFriendList: (state, action = {}) => {
      const { payload: users } = action;
      state.friendList = users;
    },
  },
});

const { addUser, addFriendList } = userSlice.actions;
const userReducer = userSlice.reducer;

export { addUser, addFriendList, userReducer };
export default userSlice;
